export default __webpack_public_path__ + "static/media/webdoc-logo.94eaccb5.png";